import {
  Device,
  NavPill,
  PunchHole,
  Screen,
  StatusBar,
} from "./android.styles";
import { BatteryGlyph, SignalGlyph, WifiGlyph } from "./androidGlyphs";
import { AndroidLockScreen } from "./AndroidLockScreen";
import { AndroidMessagesScreen } from "./AndroidMessagesScreen";
import type { PhoneMessage, PhoneScreen } from "../phoneMessage";

export { ANDROID_PHONE_HEIGHT, ANDROID_PHONE_WIDTH } from "./android.styles";

export interface AndroidPhoneProps {
  message: PhoneMessage;
  screen?: PhoneScreen;
  onRetry?: () => void;
}

export function AndroidPhone({
  message,
  screen = "app",
  onRetry,
}: AndroidPhoneProps) {
  const locked = screen === "lock";
  return (
    <Device>
      <Screen sx={locked ? { color: "#fff" } : undefined}>
        {locked ? (
          <AndroidLockScreen message={message} onRetry={onRetry} />
        ) : (
          <AndroidMessagesScreen message={message} onRetry={onRetry} />
        )}
        <PunchHole />
        <StatusBar>
          <span>9:41</span>
          <span>
            <WifiGlyph />
            <SignalGlyph />
            <BatteryGlyph />
          </span>
        </StatusBar>
        <NavPill />
      </Screen>
    </Device>
  );
}
